const LinkSvg = ({
  height = 24,
  width = 24,
  viewBox = '0 0 24 24',
  className = '',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  className?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 7H18C20.7614 7 23 9.23858 23 12C23 14.7614 20.7614 17 18 17H15M9 17H6C3.23858 17 1 14.7614 1 12C1 9.23858 3.23858 7 6 7H9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12H16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LinkSvg;
